import styled from 'styled-components';

export const CenteredDiv = styled.div`
    text-align: center;
`;
